export default __webpack_public_path__ + "static/ttube-about-e08d373401c4949b7c897135565f2a72.jpg";